package com.havn.app.features.auth.presentation

actual object HavnAuthPlatform {
    actual val supportsAppleSignIn: Boolean = false
}
